import { cardsService, type Card } from './cards.service'
import { decksService, type Deck } from './decks.service'
import { spacesService, type Space } from './spaces.service'
import { battlesService } from './battles.service'
import { authService, type AuthUser } from './auth.service'

export type { Card, Deck, Space, AuthUser }

export const api = {
  getCards: async (params?: any) => {
    const result = await cardsService.getCards(params, params?.page, params?.limit)
    return { success: true, data: result.data, pagination: result.pagination }
  },
  
  getCard: async (id: string) => {
    const card = await cardsService.getCard(id)
    return { success: !!card, data: card }
  },
  
  getAllCards: async () => {
    const cards = await cardsService.getAllCards()
    return { success: true, data: cards }
  },
  
  getEditions: () => cardsService.getEditions(),
  getFactions: () => cardsService.getFactions(),
  getTypes: () => cardsService.getTypes(),
  
  getDecks: async () => {
    const decks = await decksService.getDecks()
    return { success: true, data: decks }
  },
  
  getDeck: async (id: string) => {
    const deck = await decksService.getDeck(id)
    return { success: !!deck, data: deck }
  },
  
  createDeck: async (data: any) => {
    const deck = await decksService.createDeck(data)
    return { success: true, data: deck }
  },
  
  updateDeck: async (id: string, data: any) => {
    await decksService.updateDeck(id, data)
    return { success: true }
  },
  
  deleteDeck: async (id: string) => {
    await decksService.deleteDeck(id)
    return { success: true }
  },
  
  getSpaces: async () => {
    const spaces = await spacesService.getSpaces()
    return { success: true, data: spaces }
  },
  
  getSpace: async (slug: string) => {
    const space = await spacesService.getSpace(slug)
    return { success: !!space, data: space }
  },
  
  createSpace: async (data: any) => {
    const space = await spacesService.createSpace(data)
    return { success: true, data: space }
  },
  
  getBattles: async () => {
    const battles = await battlesService.getBattles()
    return { success: true, data: battles }
  },
  
  getBattle: async (id: string) => {
    const battle = await battlesService.getBattle(id)
    return { success: !!battle, data: battle }
  },
  
  createBattle: async (data: any) => {
    const battle = await battlesService.createBattle(data)
    return { success: true, data: battle }
  },
  
  login: async (data: any) => {
    const result = await authService.login(data)
    return result
  },
  
  register: async (data: any) => {
    const result = await authService.register(data)
    return result
  },
  
  logout: async () => {
    await authService.logout()
  },
  
  me: async () => {
    const user = await authService.me()
    return { success: !!user, data: user }
  },
  
  startBattle: (deck1Id: string, deck2Id: string) => {
    return { success: false, error: 'Not implemented' }
  },
  
  simulateBattle: (deck1Id: string, deck2Id: string) => {
    return { success: false, error: 'Not implemented' }
  },
}

export const fetchCards = async (params?: any) => {
  return api.getCards(params)
}
